export default __webpack_public_path__ + "static/media/mars19.a7bd763f.gif";